import { apiRequest } from "./client";

export async function fetchDashboard(date) {
  const response = await apiRequest(
    `/api/v1/dashboard?date=${encodeURIComponent(date)}`
  );
  return response.json();
}

export async function updateDashboardUserOrder(userIds) {
  const response = await apiRequest("/api/v1/dashboard/user-order", {
    method: "PUT",
    body: JSON.stringify({ user_ids: userIds }),
  });
  if (!response.ok) {
    throw new Error("並び順の保存に失敗しました");
  }
  return response.json();
}
